export enum APP_STEP {
    ABOUT_YOU = 0,
    YOUR_PROPERTY = 1,
    YOUR_COVER = 2,
    QUOTES = 3,
    PAYMENT = 4,
    THANK_YOU = 5
}

export interface RecallQuoteDetails {
    reference: string | null;
    surname: string | null;
    dob: string | null;
    allow_expired: boolean | null;
}
